@if (isLoading) {
  <div class="content-loading">
    <div class="spinner">
      <img src="assets/images/loading.gif" alt="Loading content">
    </div>
  </div>
}
<div [ngClass]="blurFilter">
  <ng-content ></ng-content>
</div>
